import { Component } from 'react'
import { withRouter } from 'react-router-dom'

class ScrollIntoView extends Component {
	componentDidMount  () {
		return window.scrollTo(0, 0)
	}

	componentDidUpdate (prevProps) {
		if (this.props.location !== prevProps.location) window.scrollTo(0, 0)
	}

	render() {
		return this.props.children
	}
}

export default withRouter(ScrollIntoView)
